import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-794c8528"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restart_account_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "restart_account_title" }, "転職支援サービスの再開をご希望の方", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "restart_account_description" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_description_punctuation" }, "下記の項目をご記入のうえ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_description_punctuation" }, "「送信」ボタンを押してください")
], -1))
const _hoisted_4 = { class: "restart_account_base_input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "restart_account_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_label" }, "フリガナ"),
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_required" }, "必須")
], -1))
const _hoisted_6 = { class: "restart_account_input_item_text_column_2" }
const _hoisted_7 = { class: "restart_account_input_item_text_column_2_left" }
const _hoisted_8 = { class: "restart_account_input_item_text_column_2_right" }
const _hoisted_9 = { class: "restart_account_base_input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "restart_account_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_label" }, "生年月日"),
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_required" }, "必須")
], -1))
const _hoisted_11 = { class: "restart_account_input_item_dateofbirth" }
const _hoisted_12 = { class: "restart_account_base_input" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "restart_account_input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_label" }, "メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "restart_account_input_title_required" }, "必須")
], -1))
const _hoisted_14 = { class: "restart_account_input_mailAddress" }

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { object, string } from 'yup';
import { getToken } from '@/api/csrfEndpoint';
import { putRestartAccount } from '@/api/restartAccount';

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import BaseYmdForm from '@/components/BaseYmdForm.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import VALIDATON_ERRORS from '@/constants/validationErrors';
import Loading from '@/components/Loading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RestartAccountView',
  setup(__props) {

const isLoading = ref(false);

const schema = object({
  firstNameKana: string()
    .label('フリガナ')
    .required(VALIDATON_ERRORS.REQUIRED)
    .matches(/^[ァ-ヶー]*$/, VALIDATON_ERRORS.ZEN_KANA),
  lastNameKana: string()
    .label('フリガナ')
    .required(VALIDATON_ERRORS.REQUIRED)
    .matches(/^[ァ-ヶー]*$/, VALIDATON_ERRORS.ZEN_KANA),
  birthDate: string()
    .label('生年月日')
    .required()
    .matches(/^\d{4}-\d{2}-\d{2}$/, VALIDATON_ERRORS.REQUIRED),
  mailAddress: string()
    .label('メールアドレス')
    .required(VALIDATON_ERRORS.REQUIRED)
    .email('正しいメールアドレスを入力してください。')
});

const { meta, errors } = useForm({
  validationSchema: schema,
});
const { value: firstNameKana } = useField('firstNameKana', undefined, {
  initialValue: '',
});
const { value: lastNameKana } = useField('lastNameKana', undefined, {
  initialValue: '',
});
const { value: birthDate } = useField('birthDate', undefined, {
  initialValue: '',
});
const { value: mailAddress} = useField('mailAddress', undefined, {
  initialValue: '',
});

const nameKanaErrors = computed(() => {
  if (errors.value.firstNameKana) {
    return errors.value.firstNameKana;
  }
  if (errors.value.lastNameKana) {
    return errors.value.lastNameKana;
  }
  return '';
});


const router = useRouter();

// 送信ボタン押下時処理
const send = async () => {
  try {
    isLoading.value = true;

    //csrfトークンを取得
    const res = await getToken();
    const csrfToken = res.csrfToken;

    // 運用再開APIを実行
    await putRestartAccount({
      firstNameKana: firstNameKana.value,
      lastNameKana: lastNameKana.value,
      birthDate: birthDate.value,
      mailAddress: mailAddress.value
    },
    csrfToken);

    router.push({ name: 'q02' });
  } finally {
    isLoading.value = false;
  }
};

// ログインへ戻るボタン押下時処理
const back = () => {
  router.push({ name: 'a10' });
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(lastNameKana),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(lastNameKana) ? (lastNameKana).value = $event : null)),
              placeholder: "セイ",
              maxlength: 50,
              isError: !!_unref(errors).lastNameKana
            }, null, 8, ["modelValue", "isError"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(BaseTextForm, {
              modelValue: _unref(firstNameKana),
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(firstNameKana) ? (firstNameKana).value = $event : null)),
              placeholder: "メイ",
              maxlength: 50,
              isError: !!_unref(errors).firstNameKana
            }, null, 8, ["modelValue", "isError"])
          ])
        ]),
        (_unref(errors).lastNameKana || _unref(errors).firstNameKana)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: [_unref(nameKanaErrors)]
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(BaseYmdForm, {
            modelValue: _unref(birthDate),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(birthDate) ? (birthDate).value = $event : null)),
            placeholder: "2000-01-01",
            yearSort: "desc"
          }, null, 8, ["modelValue"])
        ])
      ]),
      (_unref(errors).birthDate)
        ? (_openBlock(), _createBlock(ErrorMessage, {
            key: 0,
            errors: [_unref(errors).birthDate]
          }, null, 8, ["errors"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(BaseTextForm, {
            modelValue: _unref(mailAddress),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(mailAddress) ? (mailAddress).value = $event : null)),
            placeholder: "aaa@massmedian.com",
            type: "email"
          }, null, 8, ["modelValue"])
        ]),
        (_unref(errors).mailAddress)
          ? (_openBlock(), _createBlock(ErrorMessage, {
              key: 0,
              errors: [_unref(errors).mailAddress]
            }, null, 8, ["errors"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(BaseButton, {
        class: "restart_account_button",
        disabled: !_unref(meta).valid,
        onClick: send
      }, {
        default: _withCtx(() => [
          _createTextVNode("送信")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(BaseButton, {
        class: "restart_account_button",
        theme: "secondary",
        onClick: back
      }, {
        default: _withCtx(() => [
          _createTextVNode("ログインへ戻る")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})